module.exports = __webpack_public_path__ + "static/media/mainimg-01.68328aa3.png";